(() => {
  const selector = '.gpo-container .gpo-choicelist.gpo-checkbox .choicelist-item__thumbnail.image';
  let modal, modalImage, modalCaption, lastTrigger;
  const labelOf = (thumbnail) => thumbnail.closest('.gpo-choicelist')?.querySelector('.choicelist-item__value')?.textContent?.trim() || 'Wzór';
  function closePreview() {
    if (!modal || modal.hidden) return;
    modal.hidden = true;
    document.body.classList.remove('cookielab-globo-preview-open');
    modalImage.removeAttribute('src');
    if (lastTrigger && document.contains(lastTrigger)) lastTrigger.focus();
  }
  function ensureModal() {
    if (modal) return modal;
    modal = document.createElement('div');
    modal.id = 'cookielab-globo-preview';
    modal.hidden = true;
    modal.setAttribute('role', 'dialog');
    modal.setAttribute('aria-modal', 'true');
    modal.setAttribute('aria-label', 'Podgląd wybranego wzoru');
    modal.innerHTML = '<div class="cookielab-globo-preview__panel"><button class="cookielab-globo-preview__close" type="button" aria-label="Zamknij podgląd">&times;</button><img class="cookielab-globo-preview__image" alt=""><div class="cookielab-globo-preview__caption"></div></div>';
    document.body.appendChild(modal);
    modalImage = modal.querySelector('.cookielab-globo-preview__image');
    modalCaption = modal.querySelector('.cookielab-globo-preview__caption');
    modal.addEventListener('click', (event) => {
      if (event.target === modal || event.target.closest('.cookielab-globo-preview__close')) closePreview();
    });
    return modal;
  }
  function previewSourceOf(image) {
    const candidate = image.currentSrc || image.src;
    try {
      const url = new URL(candidate, window.location.href);
      url.searchParams.set('width', '1200');
      return url.href;
    } catch (error) {
      return candidate;
    }
  }
  function openPreview(thumbnail) {
    const source = thumbnail.querySelector('img');
    if (!source) return;
    const dialog = ensureModal();
    const label = labelOf(thumbnail);
    lastTrigger = thumbnail;
    modalImage.src = previewSourceOf(source);
    modalImage.alt = label;
    modalCaption.textContent = label;
    dialog.hidden = false;
    document.body.classList.add('cookielab-globo-preview-open');
    dialog.querySelector('.cookielab-globo-preview__close').focus();
  }
  function prepare(root = document) {
    root.querySelectorAll(selector).forEach((thumbnail) => {
      if (thumbnail.dataset.cookielabPreviewReady) return;
      thumbnail.dataset.cookielabPreviewReady = 'true';
      thumbnail.setAttribute('role', 'button');
      thumbnail.setAttribute('tabindex', '0');
      thumbnail.setAttribute('aria-label', 'Powiększ zdjęcie: ' + labelOf(thumbnail));
    });
  }
  document.addEventListener('click', (event) => {
    const thumbnail = event.target.closest(selector);
    if (!thumbnail) return;
    event.preventDefault();
    event.stopPropagation();
    openPreview(thumbnail);
  }, true);
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') return closePreview();
    if ((event.key === 'Enter' || event.key === ' ') && event.target.matches(selector)) {
      event.preventDefault();
      event.stopPropagation();
      openPreview(event.target);
    }
  });
  const initialize = () => {
    prepare();
    new MutationObserver((mutations) => {
      for (const mutation of mutations) for (const node of mutation.addedNodes) {
        if (node.nodeType === Node.ELEMENT_NODE) prepare(node);
      }
    }).observe(document.body, { childList: true, subtree: true });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, { once: true });
  else initialize();
})();
